import {fetchJson} from './fetchJson';

export default {
  generateComplianceReport: (data) => fetchJson('/compliance/reports', data),
  getComplianceReports: () => fetchJson('/compliance/reports'),
  downloadReport: (reportId) => fetchJson(`/compliance/reports/${reportId}/download`, {
    responseType: 'blob'
  })
};